import { render, staticRenderFns } from "./WebClock.vue?vue&type=template&id=05f2ba82&scoped=true&"
import script from "./WebClock.vue?vue&type=script&lang=js&"
export * from "./WebClock.vue?vue&type=script&lang=js&"
import style0 from "./WebClock.vue?vue&type=style&index=0&id=05f2ba82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f2ba82",
  null
  
)

export default component.exports